export default "__VITE_ASSET__BN6Jw25F__"